<template>
  <div>
      <div class="row">
        <div class="col">
          <Notifications />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <WaypointsCard class="card mb-3" title="Planirano"
            subTitle="za danes"
            v-if="worker.id.value"
          />
          <WaypointsCard class="card mb-3" title="Planirano"
            subTitle="za jutri"
            :day="tomorrow"
            v-if="worker.id.value"
          />
        </div>
        <div class="col-md-4">
          <ServiceOrdersCard class="card mb-3" title="Moji servisni nalogi" v-if="worker.id.value"
            subTitle="Accepted, Inprogress"
            statuses="Accepted,InProgress"
            :showOwner="false"
            :ownerID="worker.id.value"
          />
        </div>
        <div class="col-md-4">
          <InternalOrdersCard class="card mb-3" title="Interni nalogi" subTitle="Accepted, zame" :ownerID="worker.id.value" statuses="Accepted" v-if="worker.id.value" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
        <WarehouseTransfersCard class="card mb-3"
          v-if="worker.activeWarehouse?.value?.id"
          :toWarehouseID="worker.activeWarehouse?.value?.id"
          statuses="New,MovementOrder" subTitle="Za v moj trenutni avto" />
        </div>
        <div class="col-md-6">
          <WorkersCard class="card mb-3" title="Servisni nalogi in ure" />

          <DevicesCard class="card mb-3" />
        </div>
      </div>

  </div>
</template>

<script setup>
import dayjs from "dayjs"
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { useWorker } from "../composition-api/useWorker"
import WarehouseTransfersCard from "../components/WarehouseTransfersCard.vue"
import WorkersCard from "../components/WorkersCard.vue"
import ServiceOrdersCard from "../components/ServiceOrdersCard.vue"
import WaypointsCard from "../components/WaypointsCard.vue"
import InternalOrdersCard from "../components/InternalOrdersCard.vue"
import Notifications from "../components/Notifications.vue"

defineOptions({ name: "HomeWorker" })

const { worker } = useWorker()

const tomorrow = computed(() => dayjs().add(1, "day").format("YYYY-MM-DD"))
</script>
